<template>
  <div class="lang-wrapper d-flex flex-column align-items-center justify-content-center">
    <router-link to="/best-ecn-broker">
      <img src="../assets/uk.png" alt="English Language" />
    </router-link>
    <router-link to="/best-ecn-broker/fr">
      <img class="py-3" src="../assets/fr.png" alt="French Language" />
    </router-link>
    <router-link to="/best-ecn-broker/it">
      <img src="../assets/it.png" alt="Italian Language" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Language"
};
</script>

<style scoped lang="scss">
.lang-wrapper {
  z-index: 9999;
  position: fixed;
  border-radius: 5px;
  top: 50%;
  transform: translate(-80%, -50%);
  left: 0;
  height: auto;
  width: auto;
  background: rgba(255, 255, 255, 0.5);
  padding: 10px 10px 10px 10px;
  border-right: 5px solid red;
  opacity: 0.3;
  transition: 1s;
  &:hover {
      opacity: 1;
      transform: translate(0%, -50%)
  }
  img {
      transition: .5s;
      &:hover {
          transform: scale(1.1)
      }
  }
}
</style>
